'use client';

import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

// Controls must wait until React can retain input and handle clicks.
export function useHydrated() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
